import styled from 'styled-components'

const StyledHeader = styled.header`
  
  width:100vw;
  
  nav {
    display: flex;
    justify-content: center;
  }

  a{
    margin: 1.25rem;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center; 
    align-items: center;
    color: #ff6647;
  }
  
  
  .icon {
    width: 48px;
    height: 48px;
    transition: 0.3s;
  }

  svg:hover {
    color: #a83720;
    transform : scale(0.9);
  }

  .icon:active {
    color #ff6647;
    transform : scale(1);
  }
  

  
`

export default StyledHeader